import { Text, View } from '@mirai/ui';
import React from 'react';

import * as style from './routes.module.css';

export const Deals = () => (
  <>
    <View tag="section" className={[style.section, style.box, style.accent]}>
      <View className={style.wrapper}>
        <Text bold headline level={1}>
          Deals
        </Text>
        <Text>Discover exclusive hotel offers tailored just for you.</Text>
      </View>
    </View>
    <View className={[style.wrapper, style.box]}>
      <View data-mirai-component="deals" data-id={new URLSearchParams(location.search).get('dealId') || '350807'} />
    </View>
  </>
);
